import { render, staticRenderFns } from "./appointments.vue?vue&type=template&id=8b4a72de&scoped=true&"
import script from "./appointments.vue?vue&type=script&lang=js&"
export * from "./appointments.vue?vue&type=script&lang=js&"
import style0 from "./appointments.vue?vue&type=style&index=0&id=8b4a72de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4a72de",
  null
  
)

export default component.exports